var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A606A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.907 24.87h-8.93a.993.993 0 0 1-.993-.993V6.017c0-.548.445-.993.993-.993h8.93a.991.991 0 1 0 0-1.984h-8.93A2.98 2.98 0 0 0 3 6.016v17.86a2.98 2.98 0 0 0 2.977 2.978h8.93a.991.991 0 1 0 0-1.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.598 14.24-6.033-5.953A.992.992 0 1 0 19.172 9.7l4.311 4.254H11.93a.991.991 0 1 0 0 1.985h11.553l-4.311 4.255a.992.992 0 1 0 1.393 1.413l6.033-5.954a.994.994 0 0 0 0-1.413z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-logout.2533a886f349ce03f7bd09f8a5ea5b3f.svg";